import React from "react";
import getClassNameFactory from "../../utilities/classNames";
import Heading from "../../elements/Heading";
import { Rank, Sizes } from "../../core";
import NoResults from "./components/NoResults";
import Result from "./components/Result";

var SearchResults = function SearchResults(_ref) {
  var children = _ref.children,
      title = _ref.title;
  var getClassName = getClassNameFactory(SearchResults.displayName);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName()
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "title"
    })
  }, /*#__PURE__*/React.createElement(Heading, {
    rank: Rank.Second,
    type: Sizes.XTRASMALL
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "results"
    })
  }, children));
};

SearchResults.displayName = "SearchResults";
SearchResults.NoResults = NoResults;
SearchResults.Result = Result;
export default SearchResults;